<template>
  <div class="animated fadeIn">
    <div id="Dashboard">
    	<h1 v-if="show_init_msg" class="text-center w-100">
    		<p><i class="icon icon-rocket text-primary"></i> 建構中...</p>
    		<p @click="sendMsg()">請先點選其他功能</p>
    	</h1>

    	<b-row>
  			<b-col cols="12" sm="6" lg="3" v-if="show_mqtt_socket">
  				<b-card :no-body="true">
			    	<b-card-body class="p-0 clearfix">
			            <i class="fa fa-cogs bg-primary p-4 font-2xl mr-3 float-left"></i>
			            <div class="h5 text-primary mb-0 pt-3">Socket Server</div>
			            <div class="text-uppercase font-weight-bold font-xs text-success">ONLINE</div>
			        </b-card-body>
		    	</b-card>
	    	</b-col>

	    	<b-col cols="12" sm="6" lg="3" v-if="show_mqtt">
	    		<b-card :no-body="true">
			        <b-card-body v-if="show_mqtt" class="p-0 clearfix">
			            <i class="fa fa-cogs bg-info p-4 font-2xl mr-3 float-left"></i>
			            <div class="h5 text-primary mb-0 pt-3">MQTT Server</div>
			            <div class="text-uppercase font-weight-bold font-xs text-success">ONLINE</div>
			        </b-card-body>
		        </b-card>
	        </b-col>
		</b-row>
    </div>
  </div>
</template>

<script>

import config from '@/config/global'
import io from 'socket.io-client'

let $socket = null;

export default {
  name: 'dashboard',

  data() {
  	return {
	  	show_init_msg: true,
	  	show_mqtt_socket: false,
	  	show_mqtt: false,
  	}
  },

  mounted(){

  	let app = this;

    $socket = io(config.socket_entry, {
      origins: '*:*',
      secure: true,
      forceNew: true,
      transports: ['polling'],
      cookie: false,
    });
    	
  	$socket.on('connect', () => {
  		app.show_init_msg = false;
  		// console.info('Socket connected');
  	});

  	$socket.on('mqtt_socket_connected', (data) => {
  		// console.info('mqtt_socket_connected:', data);
  		$socket.emit('mqtt_socket', {message:'from client'});

  		app.show_mqtt_socket = true;
  		app.show_init_msg = false;
  	});

  	$socket.on('mqtt_connected', (data) => {
  		// console.info('mqtt_connected');
  		app.show_mqtt = true;
  		app.show_init_msg = false;
  	});
	
  },

  methods: {
  	sendMsg() {
  		console.info('send socket...', $socket);
  		$socket.emit('mqtt_socket', {message:1234});
  	}
  }
}
</script>
